import { withCommonRenderer } from '../../common/ui/renderer-common/index.tsx';
import { ForgeUIExtension as Renderer } from './main.tsx';

export const ForgeUIExtension = withCommonRenderer(Renderer);
